/* window.BotBalance: шаблонный «Баланс», который PAGES зовёт как раньше (init, mount, fill, after, S, focus, giftIn, openLedger).
   Один экран: в серверном режиме тот же движок получает balanceServer вместо демо-данных. Листы рисует BotCore.sheet. */
import { definePageModule } from '../../bridge/page-module';
import { isServerMode } from '../../platform/server-mode';
import { Balance, type BalanceApi } from './Balance';
import { balanceServer } from './balance-server';
import { createBalance } from './engine';

let api: BalanceApi;

/** Экран берёт api при монтаже: installBalance уже вызван */
export function balanceApi() {
  return api;
}

export function installBalance() {
  const server = isServerMode();
  const b = createBalance();
  if (server) b.init({ server: balanceServer });
  api = b;
  definePageModule({
    global: 'BotBalance',
    PREFIX: 'bl',
    TESTS: server ? [] : b.TESTS as [string, [string, string][]][],
    S: b.S,
    Page: Balance,
    init(o) {
      b.init(o);
    },
    fill(k) {
      if (!server) b.fill(k);
    },
    after() {
      b.after();
    },
    beforeUnmount() {
      b.unmount();
    },
    extra: {
      planChanged: b.planChanged,
      focus: b.focus,
      balanceChanged: b.balanceChanged,
      giftIn: b.giftIn,
      openLedger: b.openLedger,
    },
  });
}
